import auth from "@/api/model/auth"
import system from "@/api/model/system"
import tools from "@/api/model/tools"

export default {
	auth,
	system,
	tools
}
